export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Lt-cfc08c4728e6e78526d89f70def0fc7d.woff2";